import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const INVESTOR: AppRouteRecordRaw = {
  path: '/investor',
  name: 'investor',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: '投资人管理',
    icon: 'icon-user',
    requiresAuth: true,
    order: 11,
    roles: ['admin'],
  },
  children: [
    {
      path: 'list',
      name: 'InvestorList',
      component: () => import('@/views/investor/index.vue'),
      meta: {
        locale: '投资人列表',
        requiresAuth: true,
        roles: ['admin'],
      },
    },
    {
      path: 'form',
      name: 'InvestorForm',
      component: () => import('@/views/investor/form.vue'),
      meta: {
        locale: '投资人表单',
        requiresAuth: true,
        roles: ['admin'],
        hideInMenu: true,
      },
    },
    {
      path: 'bill',
      name: 'InvestorBillList',
      component: () => import('@/views/investor-bill/index.vue'),
      meta: {
        locale: '投资人账单',
        requiresAuth: true,
        roles: ['admin'],
      },
    },
    {
      path: 'bill-form',
      name: 'InvestorBillForm',
      component: () => import('@/views/investor-bill/form.vue'),
      meta: {
        locale: '投资人账单表单',
        requiresAuth: true,
        roles: ['admin'],
        hideInMenu: true,
      },
    },
    {
      path: 'settlement-bill',
      name: 'InvestorSettlementBill',
      component: () => import('@/views/investor-settlement-bill/index.vue'),
      meta: {
        locale: '投资人结算明细',
        requiresAuth: true,
        roles: ['admin'],
      },
    },
    {
      path: 'settlement-summary',
      name: 'InvestorSettlementSummary',
      component: () => import('@/views/investor-settlement-summary/index.vue'),
      meta: {
        locale: '投资人结算汇总',
        requiresAuth: true,
        roles: ['admin'],
      },
    },
  ],
};

export default INVESTOR;
